// extracted by mini-css-extract-plugin
var _1 = "PendingStakedEthStyle-module__activationTimeBoxWrapper___HMGOw";
var _2 = "PendingStakedEthStyle-module__headerTitleWrapper___iyAE1";
var _3 = "PendingStakedEthStyle-module__process___T52Pn";
var _4 = "PendingStakedEthStyle-module__stats___HOudX";
var _5 = "PendingStakedEthStyle-module__statsItem___q4VMb";
var _6 = "PendingStakedEthStyle-module__tableWrapper___HxzVt";
var _7 = "PendingStakedEthStyle-module__wrapper___BYFYJ";
export { _1 as "activationTimeBoxWrapper", _2 as "headerTitleWrapper", _3 as "process", _4 as "stats", _5 as "statsItem", _6 as "tableWrapper", _7 as "wrapper" }
